export enum UserRights {
    'ADMIN',
    'WRITE',
    'TEMPO',
    'VIEW'
}

export interface IUsers {
    user: string;
    rights: string;
    userId: string;
}

export interface IClose {
    type: string;
    ind: boolean;
}

export class Institution {

    constructor(
        public $key: string,
        public institutionId: string,
        public institutionName: string,
        public institutionAddress: string,
        public institutionCity: string,
        public institutionProv: string,
        public institutionPostalCode: string,
        public institutionCountry: string,
        public institutionPhone: string,
        public institutionPhoneExt: string,
        public institutionEmail: string,       
        public institutionRespOrgId: string,
        public institutionRespOrgName: string,
        public institutionAdmRegion: string,
        public institutionType: string,
        public contactLastName: string,
        public contactFirstName: string,
        public contactTitle: string,
        public contactPhone: string,
        public contactPhoneExt: string,
        public contactEmail: string,
        public student: boolean,
        public guardDuty: boolean,
        public buses: boolean,
        public teacher: boolean,
        public smsNotification: boolean,
        public emailNotification: boolean,
        public phoneNotification: boolean,
        public powerUserTransfert: boolean,
        public preSchool: boolean,
        public primarySchool: boolean,
        public secondarySchool: boolean,
        public adultSchool: boolean,
        public professionnelSchool: boolean,
        public collegeSchool: boolean,
        public universitySchool: boolean,
        public languageFrench: boolean,
        public languageEnglish: boolean,
        public users: IUsers[],
        public close: IClose[]) {
    }

    static fromJsonArray(json: any[]): Institution[] {
        return json.map(Institution.fromJson);
        // même chose: return json.map(array => Institution.fromJson(array));
    }

    static fromJson({
        $key,
        institutionId,
        institutionName,
        institutionAddress,
        institutionCity,
        institutionProv,
        institutionPostalCode,
        institutionCountry,
        institutionPhone,
        institutionPhoneExt,
        institutionEmail,
        institutionRespOrgId,
        institutionRespOrgName,
        institutionAdmRegion,
        institutionType,
        contactLastName,
        contactFirstName,
        contactTitle,
        contactPhone,
        contactPhoneExt,
        contactEmail,
        student,
        guardDuty,
        buses,
        teacher,
        smsNotification,
        emailNotification,
        phoneNotification,
        powerUserTransfert,
        preSchool,
        primarySchool,
        secondarySchool,
        adultSchool,
        professionnelSchool,
        collegeSchool,
        universitySchool,
        languageFrench,
        languageEnglish,
        users,
        close,
    }): Institution {

        return new Institution(
            $key,
            institutionId,
            institutionName,
            institutionAddress,
            institutionCity,
            institutionProv,
            institutionPostalCode,
            institutionCountry,
            institutionPhone,
            institutionPhoneExt,
            institutionEmail,
            institutionRespOrgId,
            institutionRespOrgName,
            institutionAdmRegion,
            institutionType,
            contactLastName,
            contactFirstName,
            contactTitle,
            contactPhone,
            contactPhoneExt,
            contactEmail,
            student,
            guardDuty,
            buses,
            teacher,
            smsNotification,
            emailNotification,
            phoneNotification,
            powerUserTransfert,
            preSchool,
            primarySchool,
            secondarySchool,
            adultSchool,
            professionnelSchool,
            collegeSchool,
            universitySchool,
            languageFrench,
            languageEnglish,
            users,
            close
        )
    }
}


// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/model/institution.ts